import MobileNotSupportedImage from '@assets/mobile-not-supported-image.svg';
import { Button } from '@mui/material';
import { pathToVP } from '@utils/route';

interface IMobileNotSupportedProps {
    title: string;
    subtitle: string;
}

const MobileNotSupported = ({ title, subtitle }: IMobileNotSupportedProps) => (
    <div className="center-container text-center font-inter">
        <p className="font-semibold text-[10rem] text-xl text-black-70">{title}</p>
        <p className="text-black-70 text-sm font-normal max-w-60 mt-2">{subtitle}</p>
        <Button variant="text" sx={{ color: 'primary.light', marginTop: '38px' }} href={pathToVP().toString()}>
            Back to home page
        </Button>
        <img src={MobileNotSupportedImage} className="mt-16" />
    </div>
);

export { MobileNotSupported };
